<template>
  <div class="bindPhone sw-container">
    <div class="common-nav">
      <span class="s1">您的位置</span>
      <span class="s2">|</span>
      <span class="s3">手机绑定</span>
    </div>
    <div class="bindPhone-main">
      <div class="bindPhone-title">手机绑定</div>
      <div class="bindPhone-title2">手机绑定</div>
      <div class="bindPhone-line"></div>
      <div class="bindPhone-box">
        <span class="bindPhone-label">手机号码</span>
        <Input v-model="phone" placeholder="手机号码" style="width: 360px" />
      </div>
      <div class="bindPhone-box">
        <span class="bindPhone-label">短信验证码</span>
        <Input v-model="code" style="width: 360px" placeholder="验证码输入">
          <div class="bindPhone-code" @click="getCode" slot="append">
            {{ codeTest }}
          </div>
        </Input>
      </div>
      <div class="bindPhone-bottom">
        <div class="bindPhone-btn" @click="submit">确认</div>
        <div class="bindPhone-btn bindPhone-btn2" @click="$router.back()">
          返回
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as api from "@/assets/api/api.js";
export default {
  name: "bindPhone",
  components: {},
  data() {
    return {
      phone: "",
      code: "",
      codeTest: "点击发送",
      codeBtn: true,
    };
  },
  created() {},
  computed: {},
  methods: {
    handleChangePage() {},
    getCode() {
      if (!this.codeBtn) {
        return;
      }
      if (!/^1\d{10}$/.test(this.phone)) {
        this.$Message.error("请填写正确的手机号码");
        return;
      }
      api
        .postData("student/sendSmsCode", {
          phone: this.phone,
          type: 1,
        })
        .then((res) => {
          this.$Message.success("验证码发送成功");
        });
      this.codeBtn = false;
      let num = 60;
      this.codeTest = num + "s";
      let timer = setInterval(() => {
        num--;
        if (num < 0) {
          clearInterval(timer);
          this.codeTest = "点击发送";
          this.codeBtn = true;
          return;
        }
        this.codeTest = num + "s";
      }, 1000);
    },
    submit() {
      if (!/^1\d{10}$/.test(this.phone)) {
        this.$Message.error("请填写正确的手机号码");
        return;
      }
      if (!this.code) {
        this.$Message.error("请填写验证码");
        return;
      }
      api.showLoading();
      api
        .postData("student/bindPhone", {
          phone: this.phone,
          vercode: this.code,
        })
        .then((res) => {
          this.$Message.success("绑定成功");
		  // console.log(res);
		  // return
          this.refresh();
        });
    },
    refresh() {
      api.postData("student/refresh", {}).then((res) => {
        let master = {
          user: res.data.user,
        };
		// console.log(res);
        if (localStorage.getItem("master")) {
          master.token = JSON.parse(localStorage.getItem("master")).token;
          localStorage.setItem("master", JSON.stringify(master));
        } else if (sessionStorage.getItem("master")) {
          master.token = JSON.parse(sessionStorage.getItem("master")).token;
          sessionStorage.setItem("master", JSON.stringify(master));
        }
		// console.log(JSON.parse(sessionStorage.getItem("master")));
		
        this.$store.commit("setMaster", master);
		// return
        this.$router.push({
          path: "/",
        });
      });
    },
  },
  watch: {},
};
</script>

<style lang="scss">
.bindPhone {
  padding-bottom: 30px;
  &-main {
    background: #fbfbfb;
    height: 600px;
    padding-top: 25px;
  }
  &-label {
    margin-right: 10px;
    font-size: 14px;
    color: #222;
    width: 70px;
  }
  &-box {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 14px;
    .ivu-input {
      height: 36px;
    }
    .ivu-input-group-append {
      width: 100px;
      cursor: pointer;
    }
  }
  &-title {
    margin-left: 18px;
    line-height: 17px;
    padding-left: 6px;
    font-size: 16px;
    border-left: 2px solid #41bf67;
  }
  &-title2 {
    font-size: 26px;
    color: #222;
    text-align: center;
    margin-top: 108px;
    margin-bottom: 20px;
  }
  &-line {
    height: 2px;
    background: #bbbbbb;
    width: 26px;
    margin: 0 auto 28px;
  }
  &-bottom {
    margin-top: 44px;
    display: flex;
    justify-content: center;
  }
  &-btn {
    width: 120px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    background: #31af58;
    color: #fff;
    border-radius: 4px;
    font-size: 14px;
    cursor: pointer;
  }
  &-btn:hover {
    background: rgba(49, 175, 88, 0.8);
  }
  &-btn2 {
    background: #222222;
    margin-left: 20px;
  }
  &-btn:hover {
    background: rgba(34, 34, 34, 0.8);
  }
}
.phoneBind .code .ivu-btn{
	position: relative;
	top: -3px;
}
</style>
